import { z } from "zod";

/**
 * TextNodeSchema - Content Schema for Text Node
 *
 * Text nodes contain plain text with optional formatting.
 */
export const TextNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("text"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  text: z.string(),
  style: z.string().optional(), // Optional rendering hint
  format: z.number().optional(),
  detail: z.number().optional(),
  mode: z.enum(["normal", "token", "segmented"]).optional(),
}).strict();

export type TextNode = z.infer<typeof TextNodeSchema>;
